var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterviewSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3446_45602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0195 34.3184H25.9807",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4128 38.7285H20.5879V46.5729H29.4128V38.7285Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6455 46.5732H32.3537",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0818 3.42871C47.7066 3.42871 49.0234 4.74561 49.0234 6.37041V35.7868C49.0234 37.4116 47.7065 38.7284 46.0818 38.7284H3.91816C2.29346 38.7284 0.976562 37.4116 0.976562 35.7868V6.37041C0.976562 4.74561 2.29346 3.42871 3.91816 3.42871H46.0818Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.976562 30.8833H49.0234",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1758 -1C45.7291 -0.999993 47 0.260811 47 1.81738V10.9209C47 12.4794 45.7272 13.7363 44.1758 13.7363H36.2051L32.6689 15.7949C32.0772 16.1395 31.3262 16.0425 30.8418 15.5566C30.357 15.0703 30.2616 14.317 30.6133 13.7256C29.1592 13.6178 28 12.4081 28 10.9209V1.81738C28 0.260846 29.2709 -1 30.8242 -1H44.1758Z",
    fill: "white",
    stroke: "#0A68AC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0794 25.3867L15.9382 24.8162C15.43 24.5622 15.0146 23.8896 15.0146 23.3222V21.2574C15.0146 20.6897 15.4303 20.0174 15.9382 19.7634L17.0794 19.1926V25.3867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7212 25.3867L33.8628 24.8162C34.371 24.5622 34.7857 23.8896 34.7857 23.3222V21.2574C34.7857 20.6897 34.3707 20.0174 33.8628 19.7634L32.7212 19.1926V25.3867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0294 16.6118H20.7706C19.0607 16.6118 17.6736 17.9987 17.6736 19.7088V23.8381C17.6736 26.6871 19.9861 28.9999 22.8351 28.9999H26.9647C29.8136 28.9999 32.1262 26.6871 32.1262 23.8381V19.7088C32.1265 17.9987 30.7393 16.6118 29.0294 16.6118ZM30.062 23.8381C30.062 25.5461 28.6727 26.9351 26.965 26.9351H22.8351C21.1271 26.9351 19.7381 25.5461 19.7381 23.8381V19.7088C19.7381 19.1399 20.2014 18.6766 20.7703 18.6766H29.0291C29.599 18.6766 30.0617 19.1399 30.0617 19.7088L30.062 23.8381Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9653 24.3545V25.3867L25.4168 25.903H24.384L22.8354 25.3867V24.3545H26.9653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.707 13.2568C26.707 12.5439 25.8984 11.9663 24.9002 11.9663C23.9021 11.9663 23.0938 12.5439 23.0938 13.2568C23.0938 13.7709 23.5171 14.2107 24.126 14.4188V16.6118H25.6745V14.4182C26.2837 14.2104 26.707 13.7703 26.707 13.2568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4811 22.0317C27.4811 22.4604 27.1346 22.806 26.7069 22.806C26.2792 22.806 25.9326 22.4604 25.9326 22.0317V20.9995C25.9326 20.5705 26.2792 20.2246 26.7069 20.2246C27.1346 20.2246 27.4811 20.5705 27.4811 20.9995V22.0317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8674 22.0317C23.8674 22.4604 23.5205 22.806 23.0931 22.806C22.6657 22.806 22.3188 22.4604 22.3188 22.0317V20.9995C22.3188 20.5705 22.6657 20.2246 23.0931 20.2246C23.5205 20.2246 23.8674 20.5705 23.8674 20.9995V22.0317Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3446_45602"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviewSelect);
export default __webpack_public_path__ + "static/media/interviewSelect.dcbb130dc0b0aef18a2a1a38798564ba.svg";
export { ForwardRef as ReactComponent };